import { dasModal } from "../modal_v2.js";
import { matchService } from "./matchService_v2.js";
import { board } from "../game/gameBoard_v2.js";
import { currentMatch } from "./currentMatch_v2.js";
import { identityService } from "../profile/identityService_v2.js";
import { iPop } from "../ipop_v2.js";
import { eventHub } from "../eventHub_v2.js";
import { escapeHtml } from "../escapeHtml_v2.js";

const handleOfferDraw = () => {
  const match = matchService.getCurrentMatch().currentMatch;
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  const nachoName = identityService.parseName(nachoTurn);
  dasModal.render(
    `<br>Are you sure you want to offer a draw to ${escapeHtml(nachoName)}?<div id="drawSplainer" class="i">ⓘ</div><br>
    <button class="ruSure" id="yesDraw">Yes</button><button class="ruSure"  id="noDraw">No</button>
    <br>
    `,
  );
};

const renderDrawSplainer = (event) => {
  iPop.render({
    text: "A draw is considered a tie. Neither player wins, but it does affect your rank.</p>",
    event,
  });
};

const handleYesDraw = async () => {
  const match = matchService.getCurrentMatch().currentMatch;
  const turnName = match.turn === match.p1UserID ? match.p1Name : match.p2Name;
  const turnNamePart = identityService.parseName(turnName);
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  const nachoName = identityService.parseName(nachoTurn);
  const mode = match.mode;
  if (mode === "ownDevice") {
    dasModal.close();
    await matchService.offerDraw();
    board.render();
    dasModal.render(
      `<div class=max>A draw has been offered to ${escapeHtml(nachoName)}.</div>`,
    );
    if (currentMatch.getSize() === "normal") {
      currentMatch.render("normal");
    }
  }
  if (mode === "sameDevice") {
    dasModal.close();
    await matchService.offerDraw();
    board.render();
    if (currentMatch.getSize() === "normal") {
      currentMatch.render("normal");
    }
  }
};

const handleDecideDraw = () => {
  const match = matchService.getCurrentMatch().currentMatch;
  const turnName = match.turn === match.p1UserID ? match.p1Name : match.p2Name;
  const turnNamePart = identityService.parseName(turnName);
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  const nachoName = identityService.parseName(nachoTurn);
  dasModal.close();
  dasModal.render(
    `<div class="max flexColumn"><br>A draw has been offered by ${escapeHtml(turnNamePart)}. <span class="noWrap">Do you accept?<div id="decideDrawSplainer" class="i">ⓘ</div></span><br>
      <div class="flexRow">
        <button class="ruSure" id="decideDrawYes">Yes</button>
        <button class="ruSure"  id="decideDrawNo">No</button>
      </div>
    <br></div>
    </div>
    `,
  );
};

const renderDecideDrawSplainer = (event) => {
  iPop.render({
    text: "A draw is considered a tie. Neither player wins, but it does affect your rank.",
    event,
  });
};

const handleDecideDrawNo = async () => {
  const match = matchService.getCurrentMatch().currentMatch;
  const turnName = match.turn === match.p1UserID ? match.p1Name : match.p2Name;
  const turnNamePart = identityService.parseName(turnName);
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  const nachoName = identityService.parseName(nachoTurn);
  dasModal.close();
  dasModal.render(
    `<div class=max>The draw has been declined. It's still their turn.</div>`,
  );
  await matchService.declineDraw();
  const mode = matchService.getCurrentMatch().currentMatch.mode;
  if (mode === "sameDevice") {
    handleDrawDeclined();
  }
};

const handleDecideDrawYes = async () => {
  dasModal.close();
  matchService.acceptDraw();
  dasModal.render(`<div class=max>The match is a draw</div>`);
  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }
};

const handleDrawDeclined = () => {
  const match = matchService.getCurrentMatch().currentMatch;
  const nachoTurn = match.turn === match.p1UserID ? match.p2Name : match.p1Name;
  const nachoName = identityService.parseName(nachoTurn);
  dasModal.close();
  dasModal.render(`<div class=max>${escapeHtml(nachoName)} has declined the draw.</div>`);
  if (currentMatch.getSize() === "normal") {
    currentMatch.render("normal");
  }
  matchService.resumeAfterDeclineDraw();
};

eventHub.registerEvent("click", "noDraw", dasModal.close);
eventHub.registerEvent("click", "yesDraw", handleYesDraw);
eventHub.registerEvent("click", "decideDrawYes", handleDecideDrawYes);
eventHub.registerEvent("click", "decideDrawNo", handleDecideDrawNo);
eventHub.registerEvent("click", "drawSplainer", renderDrawSplainer);
eventHub.registerEvent("click", "decideDrawSplainer", renderDecideDrawSplainer);

export const matchDraw = {
  handleOfferDraw,
  handleDecideDraw,
  handleDrawDeclined,
};
